import {
  TableHead,
  Table,
  TableBody,
  TableContainer,
  TableRow,
} from '@mui/material';
import { useState } from 'react';

import { convertBankAdditionalRoles } from '../../../api/enumerations';
import { UserData } from '../../../api/users/types';
import { Constants } from '../constants';
import EditUserDialog from '../EditUserDialog';
import {
  Row,
  TableCellHeader,
  StyledCell,
  RoleBox,
  RoleContainer,
} from './styles';

interface TableProps {
  tableData: UserData[];
  isAdmin: boolean;
  updateUsers: () => void;
}

export default function TableUser({
  tableData,
  isAdmin,
  updateUsers,
}: TableProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<UserData>();

  const handleActiveColor = (isActive: boolean): string => {
    return isActive ? '#595959' : '#8b8c8e99';
  };
  const handleClose = (): void => setOpen(false);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCellHeader align="left">{Constants.name}</TableCellHeader>
            <TableCellHeader align="center">{Constants.email}</TableCellHeader>
            <TableCellHeader align="center">{Constants.role}</TableCellHeader>
            <TableCellHeader align="center">{Constants.access}</TableCellHeader>
            <TableCellHeader align="center">{Constants.status}</TableCellHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData?.map((user) => (
            <Row
              key={user.id}
              onClick={() => {
                if (isAdmin) {
                  setOpen(true);
                  setSelectedUser(user);
                }
              }}
            >
              <StyledCell
                align="left"
                sx={{ color: handleActiveColor(user.is_active) }}
              >
                {user.name}
              </StyledCell>
              <StyledCell
                align="center"
                sx={{ color: handleActiveColor(user.is_active) }}
              >
                {user.email}
              </StyledCell>
              <StyledCell
                align="center"
                sx={{ color: handleActiveColor(user.is_active) }}
              >
                {convertBankAdditionalRoles(user.role)}
              </StyledCell>
              <StyledCell align="center">
                <RoleContainer>
                  {user.additional_roles.map((role) => (
                    <RoleBox
                      key={role}
                      sx={{ color: handleActiveColor(user.is_active) }}
                    >
                      {convertBankAdditionalRoles(role)}
                    </RoleBox>
                  ))}
                </RoleContainer>
              </StyledCell>
              <StyledCell
                align="center"
                sx={(theme) => ({
                  color: user.is_active
                    ? theme.palette.secondary.main
                    : '#8B8C8E',
                })}
              >
                {user.is_active ? 'ativo' : 'inativo'}
              </StyledCell>
            </Row>
          ))}
        </TableBody>
      </Table>
      {open && selectedUser && isAdmin && (
        <EditUserDialog
          open={open}
          handleClose={handleClose}
          userData={selectedUser}
          updateUsers={updateUsers}
        />
      )}
    </TableContainer>
  );
}
